module.exports = "//public.zight.com/packs/media/images/pattern-2-a0e38831ef85ff88cc7c92a06c42fd61.png";